module.exports = __webpack_public_path__ + "img/badge.f8f331ef.png";